import { render, staticRenderFns } from "./TemplateDataComp.vue?vue&type=template&id=c78d62fe&scoped=true"
import script from "./TemplateDataComp.vue?vue&type=script&lang=js"
export * from "./TemplateDataComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78d62fe",
  null
  
)

export default component.exports